export { SM_PROGRAM_ID } from "@stadium/constants";

export const INVALID_PROMO_STATUS_CODE = [
  "coupon_code_unknown_error",
  "coupon_code_not_found",
  "coupon_code_not_eligible",
];

export const INVOICE_DOWNLOAD_ERROR_TOAST_ID = "invoice-download-error";
export const UPDATE_ORDER_ERROR_TOAST_ID = "update-order-error";

export const SELECT_ADDRESS_STEP_STATE = "select-address";
export const POMP_STEP_STATE = "pomp";
export const PAYMENT_SELECTION_STEP_STATE = "select-payment";
export const BILLING_DETAILS_STEP_STATE = "billing-details";
export const PAY_NOW_STEP_STATE = "pay-now";

export const CHECKOUT_STEPS_INIT_STATE_MAPPING = {
  [SELECT_ADDRESS_STEP_STATE]: {
    key: SELECT_ADDRESS_STEP_STATE,
    position: 0,
    submitted: false,
  },
  [POMP_STEP_STATE]: {
    key: POMP_STEP_STATE,
    position: 1,
    submitted: false,
  },
  [PAYMENT_SELECTION_STEP_STATE]: {
    key: PAYMENT_SELECTION_STEP_STATE,
    position: 2,
    submitted: false,
  },
  [BILLING_DETAILS_STEP_STATE]: {
    key: BILLING_DETAILS_STEP_STATE,
    position: 3,
    submitted: false,
  },
};

export const DEFAULT_CHECKOUT_STEPS = [
  SELECT_ADDRESS_STEP_STATE,
  POMP_STEP_STATE,
  PAYMENT_SELECTION_STEP_STATE,
];

export const ON_DEMAND_ITEM = "on_demand";

export const TREAT_ORDER_RESPONSE_TYPE = "treat_detail";

export const RECIPIENT_ORDER_TYPE = "spreeRecipientOrders";
